import * as config from '../config';

export async function getStepsChoicesConnections(idStory, idUser) {

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("idStory", idStory);
    myHeaders.append("idUser", idUser);

    var myInit = {
        method: 'GET',
        headers: myHeaders,
        mode: 'cors',
        cache: 'default'
    };

    var myRequest = new Request(config.API_URL + '/api/steps/links');

    let data = await (await (fetch(myRequest, myInit)
            .then(res => {
                if (res.ok)
                    return res.json()
                else {
                    console.log(res);
                    return false;
                }
            })
            .catch(err => {
                console.log('Error: ', err);
                return false;
            })
    ))
    return data;
}

export async function createStepChoice(idChoice, idStep, apparitionChance) {

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("idChoice", idChoice);
    myHeaders.append("idStep", idStep);
    myHeaders.append("apparitionChance", apparitionChance);

    var myInit = {
        method: 'POST',
        headers: myHeaders,
        mode: 'cors',
        cache: 'default'
    };

    var myRequest = new Request(config.API_URL + '/api/steps/link');

    let data = await (await (fetch(myRequest, myInit)
            .then(res => {
                if (res.ok)
                    return res.json();
                else
                    return false;
            })
            .catch(err => {
                console.log('Error: ', err);
                return false;
            })
    ))
    return data;
}

export async function updateStepChoice(stepChoice) {

    let jsonStepChoice = JSON.stringify(stepChoice);
    if (stepChoice === undefined || stepChoice === []) {
        return [];
    }

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");


    var myInit = {
        method: 'PUT',
        headers: myHeaders,
        body : jsonStepChoice,
        mode: 'cors',
        cache: 'default'
    };

    var myRequest = new Request(config.API_URL + '/api/steps/link');
    let data = await (await (fetch(myRequest, myInit)
            .then(res => {
                if (res.ok)
                    return res.json()
                else
                    return false;
            })
            .catch(err => {
                console.log('Error: ', err);
                return false;
            })
    ))

    return data;
}

export async function deleteStepChoice(idStepChoice, idUser) {

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("idStepchoice", idStepChoice);
    myHeaders.append("idUser", idUser);

    var myInit = {
        method: 'DELETE',
        headers: myHeaders,
        mode: 'cors',
        cache: 'default'
    };

    var myRequest = new Request(config.API_URL + '/api/steps/link');

    let data = await (await (fetch(myRequest, myInit)
            .then(res => {
                if (res.ok)
                    return res.json();
                else
                    return false;
            })
            .catch(err => {
                console.log('Error: ', err);
                return false;
            })
    ))
    return data;
}